import { TenantProvider } from "@/context/TenantContext";
import { useTenant } from "@/context/useTenant";
import { getRouter } from "@/projects/router";
import { RouterProvider } from "@tanstack/react-router";
import { useMemo } from "react";

function App() {
  return (
    <TenantProvider>
      <ProjectsApp />
    </TenantProvider>
  );
}

const ProjectsApp = () => {
  const { tenantId } = useTenant();
  const router = useMemo(() => getRouter(), []);

  if (!tenantId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">Tenant ID Required</h1>
          <p className="text-gray-600">
            Set{" "}
            <code className="rounded bg-gray-100 px-1">VITE_X_TENANTID</code> in
            your <code className="rounded bg-gray-100 px-1">.env</code> file.
          </p>
        </div>
      </div>
    );
  }

  return <RouterProvider router={router} />;
};

export default App;
